@for (section of sections; track section.id; let lastSection = $last) {
    <div class="form-operation-detail-sections__section">
        <p class="form-operation-detail-sections__title">{{ section.titleKey | translate }}</p>
        <div class="grid grid-i3">
            @for (field of section.fields; track field.uuid) {
                @let optionLabels = variant === 'activity' && isSelectListField(field) ? resolveFieldOptionLabels(field) : [];
                <div
                    class="form-operation-detail-sections__field"
                    [class.form-operation-detail-sections__field--full]="
                        variant === 'activity' && isSelectListField(field)
                    "
                >
                    <tec-info-group [label]="resolveFieldLabel(field, section.id)">
                        @if (variant === 'activity' && isSelectListField(field)) {
                            @if (optionLabels.length) {
                                <ul class="form-operation-detail-sections__option-list">
                                    @for (optionLabel of optionLabels; track $index) {
                                        <li
                                            [class.form-operation-detail-sections__value--mismatch]="
                                                field.matchOcrMismatch
                                            "
                                        >
                                            {{ optionLabel }}
                                        </li>
                                    }
                                </ul>
                            } @else {
                                <span>-</span>
                            }
                        } @else {
                            @if (field.showCalendar) {
                                <tec-icon name="icon-calendar" size="xs" />
                            }
                            <span
                                [class.form-operation-detail-sections__value--mismatch]="field.matchOcrMismatch"
                                >{{ resolveFieldValue(field) }}</span
                            >
                        }
                        @if (field.ageYears !== undefined && field.ageYears !== null) {
                            <tec-tag [status]="field.ageYears >= 18 ? 'success' : 'warning'">
                                {{ 'PROCESSES.DETAIL.YEARS' | translate : { years_old: field.ageYears } }}
                            </tec-tag>
                        }
                        @if (field.matchOcrMismatch) {
                            <tec-tag-icon
                                class="form-operation-detail-tag-icon"
                                size="sm"
                                [icon]="'icon-alert'"
                            />
                        }
                    </tec-info-group>
                </div>
            }
        </div>
    </div>
    @if (!lastSection) {
        <tec-divider />
    }
}
